"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _misc = require("../../misc");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getGradient = function getGradient(_ref, _ref2) {
  var variant = _ref.variant,
      progress = _ref.progress;
  var palette = _ref2.palette;
  var degrees = progress * 3.6;
  var defaultProgressColor = palette[variant].light;
  var progressColor = palette[variant].contrastText;

  if (progress > 50) {
    return "\n      linear-gradient(-90deg, ".concat(progressColor, " 50%,transparent 50%),\n      linear-gradient(").concat(degrees - 270, "deg, ").concat(progressColor, " 50%, ").concat(defaultProgressColor, " 50%)\n    ");
  }

  return "\n    linear-gradient(".concat(degrees - 90, "deg, ").concat(defaultProgressColor, " 50%, transparent 50%),\n    linear-gradient(-90deg, ").concat(progressColor, " 50%, ").concat(defaultProgressColor, " 50%)\n  ");
};

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "RadialProgressBar__Container"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme,
      radius = _ref3.radius,
      progressRadius = _ref3.progressRadius;
  return (0, _styledComponents.css)(["width:", ";height:", ";border-radius:50%;display:flex;background-image:", ""], (0, _misc.pxToRem)(radius + progressRadius), (0, _misc.pxToRem)(radius + progressRadius), function (props) {
    return getGradient(props, theme);
  });
});

var Progress = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "RadialProgressBar__Progress"
})(["", ""], function (_ref4) {
  var palette = _ref4.theme.palette,
      variant = _ref4.variant,
      radius = _ref4.radius;
  return (0, _styledComponents.css)(["color:", ";background:", ";width:", ";height:", ";line-height:", ";border-radius:50%;margin:auto;text-align:center;box-sizing:border-box;"], palette[variant].contrastText, palette[variant].main, (0, _misc.pxToRem)(radius), (0, _misc.pxToRem)(radius), (0, _misc.pxToRem)(radius));
});

var RadialProgressBar = function RadialProgressBar(_ref5) {
  var progress = _ref5.progress,
      rest = _objectWithoutProperties(_ref5, ["progress"]);

  return _react["default"].createElement(Container, _extends({}, rest, {
    progress: progress
  }), _react["default"].createElement(Progress, rest, progress, "%"));
};

RadialProgressBar.defaultProps = {
  radius: 50,
  progressRadius: 10,
  progress: 60,
  variant: 'primary'
};
RadialProgressBar.propTypes = {
  progress: _propTypes["default"].number.isRequired,
  radius: _propTypes["default"].number,
  progressRadius: _propTypes["default"].number,
  variant: _propTypes["default"].oneOf(['primary', 'secondary', 'default', 'warning', 'info', 'error', 'success'])
};
var _default = RadialProgressBar;
exports["default"] = _default;